import { create } from 'zustand'

type WalkthroughState = {
    isActive: boolean
    currentStep: number | null
    setWalkthroughState: (isActive: boolean, step: number | null) => void
}

const useWalkthroughStore = create<WalkthroughState>((set) => ({
    isActive: false,
    currentStep: null,
    setWalkthroughState: (isActive, step) => {
        set({ isActive, currentStep: step })
    },
}))

export default useWalkthroughStore
